export const COLOR = {
  white: "hsl(0, 0%, 100%)",
  black: "hsl(207, 26%, 17%)",
  grey: "#ccc",
  lightGrey: "#f2f2f2",
  lightShadow: "rgba(124, 124, 124, 0.521)",
  darkShadow: "hsl(208, 26%, 13%)",
};
